<script>
  import Chart from 'chart.js'
  import { generateChart , mixins } from 'vue-chartjs'
  import {chartTooltip} from "../../../utils";

  const { reactiveProp } = mixins

  Chart.defaults.lineWithShadow = Chart.defaults.line
  Chart.controllers.lineWithShadow = Chart.controllers.line.extend({
    draw: function (ease) {
      Chart.controllers.line.prototype.draw.call(this, ease)
      let ctx = this.chart.ctx
      ctx.save()
      ctx.shadowColor = 'rgba(0,0,0,0.15)'
      ctx.shadowBlur = 10
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 10
      ctx.responsive = true
      ctx.stroke()
      Chart.controllers.line.prototype.draw.apply(this, arguments)
      ctx.restore()
    }
  })
  const LineShadow = generateChart('line-with-shadow', 'lineWithShadow')


  export default {
    extends: LineShadow,
    name : 'Order_chart',
    mixins : [ reactiveProp ] ,
    data () {
      return {
        options: {
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: chartTooltip,
          plugins: {
            datalabels: {
              display: false
            }
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: true,
                  lineWidth: 1,
                  color: 'rgba(0,0,0,0.1)',
                  drawBorder: false
                },
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ]
          }
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>
